// extracted by css-extract-rspack-plugin
export default {"main":"main-pQW25X"};// extracted by css-extract-rspack-plugin
export default {"main":"main-pQW25X"};